<div class="checkbox-wrapper" (click)="changeValue()" (keydown.enter)="changeValue()" [class.disabled]="disabled">
  <div class="checkbox {{size}} {{color}}">
    @if (formControl) {
      <input
        [formControl]="formControl"
        [checked]="checked"
        [disabled]="disabled"
        [name]="'checkbox'+id"
        type="checkbox"
        class="checkbox-input {{notCheckedType}}"
        tabindex="0"/>
    }
    @if (!formControl) {
      <input
        [value]="value"
        [checked]="checked"
        [disabled]="disabled"
        [name]="'checkbox'+id"
        type="checkbox"
        class="checkbox-input {{notCheckedType}}"
        tabindex="0"/>
    }
    <div class="checkbox-check">
      <i class="fa-sharp fa-square-check"></i>
    </div>
    <div class="checkbox-square {{notCheckedType}}">
      @if (notCheckedType === 'outlined' && !checked) {
        <i class="fa-thin fa-square-check"></i>
      }
    </div>
  </div>
  @if (label && !labelTemplate) {
    <span class="checkbox-label">
      {{ label | translate }}
    </span>
  }
  @if (labelTemplate) {
    <span class="checkbox-label">
      <ng-content></ng-content>
    </span>
  }
</div>
